<template>
  <div>
    <TransitionModal>
      <Modal v-if="modal.open" @close="modal.open = false">
        <div class="li" v-for="file in files">
          <a
            v-if="file.download_file"
            class="pdf-link"
            :href="file.download_file.url"
            target="_blank"
            >{{ file.download_text }}
          </a>
          <svg viewBox="0 0 576 512" class="tw-w-4 ml-2 tw-text-[#d53410]">
            <path
              fill="currentColor"
              d="M195.515 374.828c-4.686-4.686-4.686-12.284 0-16.971l323.15-323.15-.707-.707-89.958.342c-6.627 0-12-5.373-12-12v-9.999c0-6.628 5.372-12 12-12L564 0c6.627 0 12 5.372 12 12l-.343 136c0 6.627-5.373 12-12 12h-9.999c-6.627 0-12-5.373-12-12L542 58.042l-.707-.707-323.15 323.15c-4.686 4.686-12.284 4.686-16.971 0l-5.657-5.657zm232-155.633l-8 8A12 12 0 0 0 416 235.68V464c0 8.837-7.164 16-16 16H48c-8.836 0-16-7.163-16-16V112c0-8.837 7.164-16 16-16h339.976c3.183 0 6.235-1.264 8.485-3.515l8-8c7.56-7.56 2.206-20.485-8.485-20.485H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V227.681c0-10.691-12.926-16.045-20.485-8.486z"
            ></path>
          </svg>
        </div>
      </Modal>
    </TransitionModal>
    <section
      class="jwb-module event-category reso reso-events tw-mt-16"
      id="events"
    >
      <header class="jwb-header" v-if="board.heading">
        <h2 class="tw-text-center">{{ board.heading }}</h2>
      </header>

      <div class="container tw-pb-24 tw-border-b tw-border-[#dedede]">
        <ul class="the-events re-li">
          <div
            class="month tw-pl-[35px] tw-mt-[65px]"
            v-for="month in filteredMonths"
          >
            <div class="li heading">
              <h3
                class="tw-text-[#d53410] tw-text-[1.5rem] tw-text-left tw-font-thin"
              >
                {{ month.name }} {{ month.year }}
              </h3>
            </div>
            <div
              class="event-row li lg:tw-flex lg:tw-justify-between"
              v-for="event in month.events"
            >
              <p class="date">
                <span class="reso-date r-bold">{{ event.date }}</span
                ><span class="reso-time">{{ event.time }} EST</span>
              </p>
              <p class="name lg:tw-w-[18%]">
                <a :href="event.link">{{ event.name }}</a>
              </p>
              <p class="address lg:tw-w-[25%]">
                <a target="_blank" :href="event.map"
                  >{{ event.address }}
                  <svg viewBox="0 0 576 512" class="tw-w-4 ml-2 external-link">
                    <path
                      fill="currentColor"
                      d="M195.515 374.828c-4.686-4.686-4.686-12.284 0-16.971l323.15-323.15-.707-.707-89.958.342c-6.627 0-12-5.373-12-12v-9.999c0-6.628 5.372-12 12-12L564 0c6.627 0 12 5.372 12 12l-.343 136c0 6.627-5.373 12-12 12h-9.999c-6.627 0-12-5.373-12-12L542 58.042l-.707-.707-323.15 323.15c-4.686 4.686-12.284 4.686-16.971 0l-5.657-5.657zm232-155.633l-8 8A12 12 0 0 0 416 235.68V464c0 8.837-7.164 16-16 16H48c-8.836 0-16-7.163-16-16V112c0-8.837 7.164-16 16-16h339.976c3.183 0 6.235-1.264 8.485-3.515l8-8c7.56-7.56 2.206-20.485-8.485-20.485H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V227.681c0-10.691-12.926-16.045-20.485-8.486z"
                    ></path></svg
                ></a>
              </p>
              <p class="download">
                <a v-if="event.download" target="_blank" :href="event.download"
                  >Download Packet
                  <svg viewBox="0 0 576 512" class="tw-w-4 ml-2 external-link">
                    <path
                      fill="currentColor"
                      d="M195.515 374.828c-4.686-4.686-4.686-12.284 0-16.971l323.15-323.15-.707-.707-89.958.342c-6.627 0-12-5.373-12-12v-9.999c0-6.628 5.372-12 12-12L564 0c6.627 0 12 5.372 12 12l-.343 136c0 6.627-5.373 12-12 12h-9.999c-6.627 0-12-5.373-12-12L542 58.042l-.707-.707-323.15 323.15c-4.686 4.686-12.284 4.686-16.971 0l-5.657-5.657zm232-155.633l-8 8A12 12 0 0 0 416 235.68V464c0 8.837-7.164 16-16 16H48c-8.836 0-16-7.163-16-16V112c0-8.837 7.164-16 16-16h339.976c3.183 0 6.235-1.264 8.485-3.515l8-8c7.56-7.56 2.206-20.485-8.485-20.485H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V227.681c0-10.691-12.926-16.045-20.485-8.486z"
                    ></path></svg
                ></a>
                <span
                  v-else-if="
                    event.multiple_download &&
                    event.multiple_download.length > 0
                  "
                  class="lightbox-link tw-cursor-pointer"
                  @click="
                    () => {
                      files = event.multiple_download
                      modal.open = true
                    }
                  "
                  >Download Packet</span
                >
              </p>
            </div>
          </div>
        </ul>

        <div class="tw-flex tw-justify-center">
          <button
            v-if="!datesLoaded"
            class="tw-font-bold tw-mt-8 tw-px-4 tw-py-2 tw-border-2 tw-border-brand-orange tw-border-solid tw-uppercase tw-flex tw-items-center hover:tw-text-white hover:tw-bg-brand-orange tw-border-2 tw-font-sans tw-rounded-full"
            @click="loadPrevious"
            :class="{
              '!tw-opacity-50 tw-!opacity-50 !tw-bg-brand-orange tw-text-white':
                loading,
            }"
          >
            <svg
              :class="{
                'tw-hidden': !loading,
                'tw-block': loading,
              }"
              class="tw-animate-spin tw--ml-1 tw-mr-3 tw-h-5 tw-w-5 tw-text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="tw-opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="tw-opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Previous {{ board.heading }}
          </button>
        </div>
        <div
          v-if="board.category === 'board-meetings' && !board.year"
          class="tac to-top"
          style="display: none"
        >
          <a class="jwb-button square orange-black" href="#events"
            >Current Meetings</a
          >
        </div>
      </div>
      <div
        v-if="board.options.includes('include_content')"
        class="container body-copy"
        :class="{ tac: board.centerContent }"
      >
        <div v-html="board.content"></div>
      </div>
    </section>
    <section class="jwb-module event-category reso reso-events" id="events">
      <div id="results" class="jwb-filter">
        <div class="container">
          <h3 class="heading">Search for Past Board Meetings</h3>
          <div class="wrapper meetings">
            <div>
              <label for="year">Meetings In</label>
              <span class="select">
                <select id="year" v-model.number="currentYear">
                  <option value="" disabled>Filter by Year</option>
                  <option v-for="year in years" :value="year">
                    {{ year }}
                  </option>
                </select>
              </span>
            </div>
            <button @click="getByYear()" class="jwb-button">Search</button>
          </div>
        </div>
      </div>
      <div class="lightbox-container"></div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Modal from './Modal.vue'
import TransitionModal from './TransitionModal.vue'
import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollToPlugin)

export default {
  components: {
    Modal,
    TransitionModal,
  },
  props: { board: { type: Object, default: () => {} } },
  data() {
    return {
      events: [],
      year: this.board.year,
      months: [],
      loading: false,
      modal: {
        open: false,
      },
      files: [],
      console: console,
      years: [2017, 2018, 2019, 2020, 2021, 2022],
      currentYear: null,
      location: location,
      datesLoaded: false,
    }
  },
  computed: {
    filteredMonths() {
      return this.months.filter((month) => {
        return month.events.length > 0
      })
    },
  },
  async created() {
    try {
      // formData required for wpAjax to work (stupid, i know)
      const formData = new FormData()
      formData.append('action', 'get_past_events')
      formData.append('category', this.board.category.slug)
      formData.append('year', this.board.year)
      formData.append('infinite', true)

      const { data } = await axios.post(this.board.adminUrl, formData)
      this.events = data.events

      const dateStart = moment().startOf('year')
      const dateEnd = moment().add(1, 'Y')
      const timeValues = []

      const months = []
      while (
        dateEnd > dateStart ||
        dateStart.format('M') === dateEnd.format('M')
      ) {
        months.push({
          name: dateStart.format('MMMM'),
          year: dateStart.format('YYYY'),
          events: this.events.filter(
            (event) =>
              moment(event.start_date).format('M YYYY') ===
              dateStart.format('M YYYY'),
          ),
        })
        dateStart.add(1, 'month')
      }
      this.months = [...months.reverse()]
    } catch (err) {
      console.log({ err, response: err.response })
    }
  },
  methods: {
    async loadPrevious() {
      try {
        this.loading = true
        this.year -= 1
        const formData = new FormData()
        formData.append('action', 'get_past_events')
        formData.append('category', this.board.category.slug)
        formData.append('year', this.year)
        formData.append('infinite', true)

        const { data } = await axios.post(this.board.adminUrl, formData)
        this.events = data.events

        const dateStart = moment([this.year]).startOf('year')
        const dateEnd = moment([this.year]).endOf('year')
        const timeValues = []

        const tempMonths = []
        while (
          dateEnd > dateStart ||
          dateStart.format('M') === dateEnd.format('M')
        ) {
          if (
            this.events.filter(
              (event) =>
                moment(event.start_date).format('M YYYY') ===
                dateStart.format('M YYYY'),
            ).length > 0
          ) {
            tempMonths.push({
              name: dateStart.format('MMMM'),
              year: dateStart.format('YYYY'),
              events: this.events.filter(
                (event) =>
                  moment(event.start_date).format('M YYYY') ===
                  dateStart.format('M YYYY'),
              ),
            })
          }
          dateStart.add(1, 'month')
        }

        this.months = [...this.months, ...tempMonths.reverse()]
        this.loading = false
      } catch (err) {
        throw new Error(err)
      }
    },
    async getByYear() {
      try {
        this.currentYear = this.currentYear
          ? this.currentYear
          : Number(moment.format('YYYY'))
        this.loading = true
        this.year = this.currentYear
        const formData = new FormData()
        formData.append('action', 'get_past_events')
        formData.append('category', this.board.category.slug)
        formData.append('year', this.year)
        formData.append('infinite', true)

        const { data } = await axios.post(this.board.adminUrl, formData)
        this.events = data.events

        const dateStart = moment([this.year]).startOf('year')
        const dateEnd = moment([this.year]).endOf('year')
        const timeValues = []

        const months = []
        while (
          dateEnd > dateStart ||
          dateStart.format('M') === dateEnd.format('M')
        ) {
          if (
            this.events.filter(
              (event) =>
                moment(event.start_date).format('M YYYY') ===
                dateStart.format('M YYYY'),
            ).length > 0
          ) {
            months.push({
              name: dateStart.format('MMMM'),
              year: dateStart.format('YYYY'),
              events: this.events.filter(
                (event) =>
                  moment(event.start_date).format('M YYYY') ===
                  dateStart.format('M YYYY'),
              ),
            })
          }
          dateStart.add(1, 'month')
        }

        this.months = months.reverse()
        this.loading = false
        this.datesLoaded = true
        gsap.to(window, {
          duration: 2,
          scrollTo: '#events',
        })
      } catch (err) {
        throw new Error(err)
      }
    },
  },
}
</script>
